import PopOver from 'chameleon/ui-stack/ui/base/popover';
import QuestionsWithPreview from 'chameleon-src/components/TrendReportingContainer/Table/components/QuestionsWithPreview';
import React from 'react';

const QuestionsAvgPerformancePopover = ({
  questionByTagData,
  tagLabel,
  onClose,
  index,
  totalQuestions,
  setPopoverIsOpen,
}) => {
  const triggerPopover = () => {
    setPopoverIsOpen(true);
    const sidebar = document.getElementById('sidebar');
    if (sidebar) sidebar.style.zIndex = '0'; // To make sure the popover is in front of the sidebar
  };

  return (
    <React.Fragment>
      <PopOver
        key={index}
        showCloseButton
        withPortal
        className="questions-avg-performance-popover"
        size="auto"
        position="end"
        accessibility={{
          'aria-label': ``,
          'aria-haspopup': 'listbox',
        }}
        onClose={onClose}
        popoverTitle={tagLabel}
        trigger={
          <a role="button" tabIndex={0} onClick={triggerPopover}>
            {totalQuestions}
          </a>
        }
      >
        <QuestionsWithPreview questionByTagData={questionByTagData} />
      </PopOver>
    </React.Fragment>
  );
};

export default QuestionsAvgPerformancePopover;
